export enum DistanceUnit {
  MILES = 'Miles',
  KILOMETERS = 'Kilometers'
}
